import logo from "./logo.svg";
import "./App.css";
import { useEffect, useState, React } from "react";
import Home from "./pages/index";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
